<template>
  <FormHeading :h="3">{{ $tt('business_details') }}</FormHeading>
  <AppRow sequence-two>
    <TextField v-model="business.name" :label="$tt('business_name')" :rules="[required]" />
    <TextField
      v-if="'id' in business"
      v-model="business.id"
      :label="$tt('company_num')"
      :rules="[required]"
    />
    <TextField
      v-if="'sector' in business"
      v-model="business.sector"
      :label="$tt('sector')"
      :hint="$tt('sector_hint')"
      :rules="[required]"
    />
    <PhoneField v-model="business.phone" :rules="[required]" />
    <TextField
      v-if="'website' in business"
      v-model="business.website"
      :label="$tt('website')"
      :hint="$tt('website_hint')"
    />
  </AppRow>
  <AddressFields
    v-if="'address' in business"
    v-model="business.address"
    :label="$tt('business_address')"
  />
</template>

<script setup lang="ts">
import type { BusinessVisaForm } from '~/types';
const { required } = useValidation();

const business = defineModel<BusinessVisaForm['business']>({ required: true });
</script>